import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import analytics from 'js/services/Analytics';
import { errorResponse, makeRequest, navigate, url } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import AppUser from "js/stores/AppUser";
import { inject, observer } from 'mobx-react';
import React from 'react';
import StepPage from './StepPage';

@inject('page')
@observer
export default class Congratulations extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      step1: 1,
      step2: 0,
      step3: 0,
      catalog: [],
      requestInProgress: 0,
      errorMessage: null,
    };

    this.id = 1;
    this.innerWidth = window.innerWidth;
  }

  componentDidMount() {
    this.launchConfetti();
  }

  launchConfetti() {
    const colors = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722'];
    const confettiHold = document.querySelector('.confetti-hold');

    if (!confettiHold) return;

    for (let i = 0; i < 600; i++) {
      const triangle = Math.random() * 10 > 5;

      const confetti = document.createElement('div');
      confetti.style.position = 'absolute';
      confetti.style.top = `${Math.random() * window.innerHeight}px`;
      confetti.style.left = `${Math.random() * window.innerWidth}px`;
      confetti.style.width = `${Math.random() * 10 + 2}px`;
      confetti.style.height = !triangle ? confetti.style.width : `${Math.random() * 10 + 10}px`;
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.opacity = Math.random();
      confetti.style.borderRadius = !triangle ? `50%` : 0;
      confetti.style.animation = `fall ${Math.random() * 2 + 0.1}s linear forwards`;
      confetti.classList.add(triangle ? 'squiggle' : 'circle');
      confettiHold.appendChild(confetti);

      setTimeout(() => {
        confetti.remove();
      }, 3000);
    }
  }

  saveItemUpload = () => {
    if (AppUser.isLoggedIn) {
      if (this.state.requestInProgress === 0) {
        this.setState({ requestInProgress: 1 })

        let item = {
          address: this.props.page.address,
          title: this.props.page.title,
          price: this.props.page.price,
          size: this.props.page.size,
          quantity: this.props.page.quantity,
          anonymous_id: this.props.page.anonymous_id,
          images: [this.props.page.primary_image],
          description: 'new trending',
          requestedBy: localStorage.getItem('requestedBy')
        };

        let myArray = this.state.catalog;
        myArray.push(item);
        this.setState({ catalog: myArray });

        makeRequest('create-new-payment-link', null, this.state.catalog)
          .then(response => {
            this.setState({ requestInProgress: 0 });
            const alias = response.data.alias;
            const phone = response.data.phone_number;

            let self = this.props.page;

            analytics.track('Offer Link Created', {
              'Item Price': self.price,
              'Item Name': self.title,
              'Item Quantity': self.quantity || '1',
              'Item Size': self.size,
              'Payment Link': url('checkout-page', { alias }),
              'Location': AppState.currentPage,
              'Event Initiated by': AppState.currentPage === 'CreateNewPaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                ? 'seller' : 'buyer'
            });

            localStorage.removeItem('requestedBy');
            localStorage.setItem('most_recent_item', alias);
            navigate(url((!phone || phone?.length) < 9 ? 'store-created-add-phone' : 'seller-payment-link-page', { alias }));
          })
          .catch(error => {
            this.setState({ requestInProgress: 0 });
            this.props.page.error = errorResponse(error);
          });
      }
    } else {
      this.props.page.setWithSignup(true);
      analytics.page('CTA_SP_create_link_signup');
      AppState.showLoginSignup('signup');
    }
  }

  render() {
    const page = this.props.page;

    return (
      <StepPage page={page} current={2} backTo={'/create-link/size'}>
        <div className='confetti-hold tw-z-50'></div>

        <div className='tw-flex tw-justify-center tw-items-center tw-h-52'>
          <img
            src="/assets/images/success.png"
            alt="Congratulations"
            style={{ width: '60px', height: '60px' }}
          />
        </div>

        <p className='tw-text-center'>
          Yay! you have just added your Item to your checkout. Continue to sign up and get your store link.
        </p>

        <ContinueButton delay={0} onClick={this.saveItemUpload} disabled={this.state.requestInProgress === 1} flat={false}>
          Continue
        </ContinueButton>
      </StepPage>
    );
  }
}
